import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
//import { pdfjs } from 'react-pdf';
// import workerSrc from 'pdfjs-dist/legacy/build/pdf.worker.min.js';

// pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

import './../Analises/analises.css';
import { getS3Url } from '../../services/funcoes';
// import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { TbPhotoSearch } from 'react-icons/tb';
import { HiChevronUp, HiChevronDown } from 'react-icons/hi';

const DocumentoCard = ({ documento, editarDocumento, excluirDocumento }) => {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(!expanded);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.5); // zoom inicial

  const nextPage = () => {
    if (pageNumber < numPages) setPageNumber(pageNumber + 1);
  };

  const prevPage = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  };

  const zoomIn = () => setScale(scale + 0.2); 
  const zoomOut = () => setScale(scale > 0.6 ? scale - 0.2 : scale);
  const [url, setUrl] = useState(null);

  useEffect(() => {

    // if (documento.idtDocAprovacao !== '') { setUrl(getS3Url(documento.idtDocAprovacao, 'Documento') + `?t=${Date.now()}`); }

    // console.log('Url: ', url);
    // setPageNumber(1);
    // setNumPages(null);

    if (documento.idtDocAprovacao) {
      const newUrl = getS3Url(documento.idtDocAprovacao, 'Documento');
      setUrl(newUrl);
      setPageNumber(1);
      setNumPages(null);
    }
  }, [documento.idtDocAprovacao]);

  return (
    <div className="card-document">
        <div className="card-header" onClick={toggle}>
          {/* <h3>{documento.idtDocAprovacao}</h3> */}
          <div>
            <TbPhotoSearch size={20} color="green" />
          </div>

          {/* <button
            onClick={() => editarDocumento()}
            className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
          >
            <FiEdit2 size={20} color="green" />
          </button>
          <button
            onClick={() => excluirDocumento()}
            className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
          >
            <FiTrash2 size={20} color="green" />
          </button> */}

          <span className="toggle-icon">{expanded ? <HiChevronUp /> : <HiChevronDown />}</span>
        </div>

        {expanded && url && (
          <div className="bg-white shadow rounded p-4 w-full max-w-3xl mx-auto">
            {/* Título do card */}
            {/* <h3 className="text-lg font-semibold text-gray-700 mb-3">
              Arquivo de Aprovação da OM
            </h3> */}

            {/* Área do PDF */}
            <div className="border rounded overflow-hidden flex justify-center items-center bg-gray-50">
                <Document
                  key={url}
                  file={url}
                  onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  loading={<span>Carregando PDF...</span>}
                  error={<span>Erro ao carregar PDF</span>}
                >
                  <Page pageNumber={pageNumber} scale={scale} renderTextLayer={false} renderAnnotationLayer={false} />
                </Document>
            </div>

            {/* Controles abaixo do PDF */}
            <div className="mt-4 space-y-4">
              {/* Paginação */}
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-2 sm:space-y-0">
                <button
                  className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                  onClick={() => setPageNumber(pageNumber - 1)}
                  disabled={pageNumber <= 1}
                >
                  Página anterior
                </button>
                <span className="text-sm text-gray-600">
                  Página {pageNumber} de {numPages}
                </span>
                <button
                  className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                  onClick={() => setPageNumber(pageNumber + 1)}
                  disabled={pageNumber >= numPages}
                >
                  Próxima página
                </button>
              </div>

              {/* Zoom */}
              <div className="flex flex-col sm:flex-row justify-center sm:space-x-4 space-y-2 sm:space-y-0">
                <button
                  className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
                  onClick={() => setScale(scale > 0.6 ? scale - 0.2 : scale)}
                >
                  -
                </button>
                <button
                  className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
                  onClick={() => setScale(scale + 0.2)}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default DocumentoCard;